export enum PaintShadeCodeType {
  Light = 'light',
  Medium = 'medium',
  Dark = 'dark',
  Unknown = 'unknown'
}
